import type { ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { View } from 'react-native'

import { ProgressBar } from '@/src/elements/progress-bar'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'

import type { TDonationData } from '../../api/types/donation'

type TDonationProgressProps = {
  donationData: TDonationData
  className?: string
}

export const DonationProgress = ({ donationData, className }: TDonationProgressProps): ReactNode => {
  const { locale } = useIntl()

  if (!donationData?.campaign || donationData.user?.userQuintile === 6) return null

  return (
    <View className={className}>
      <Typography bold colors="danger" contrast="high" className="w-full">
        <FormattedMessage id="app.banner.goal.goal" values={{ amount: donationData.campaign.donorsGoal }} />
      </Typography>
      <View className="mt-2 w-full flex-row items-center justify-center">
        <ProgressBar
          testID={TEST_ID.DONATION.PROGRESS_BAR}
          className="flex-1 bg-danger-bg-medium"
          progress={donationData.campaign.donorsPercentage}
        />
        <Typography bold colors="danger" contrast="high" className="ml-2 w-auto">
          {new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 0 }).format(
            donationData.campaign.donorsPercentage / 100,
          )}
        </Typography>
      </View>
    </View>
  )
}
